// Sad animation data
// Imported from assets/lottie_files/skydiving_woman.json
import sadAnimationData from "@lottiefiles/skydiving_woman.json" with { type: "json" };

export default sadAnimationData;
